import React, { useState } from 'react'
import { DatePicker, Button, message } from 'antd';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { getWalletAmount } from '../../../app/wallet/wallet.slice';
import { image_url, MENU_IMAGE_PATH } from '../../../Utils/baseUrl';
import commonFunction from '../../../Utils/commonFunction';
import { useDispatch } from 'react-redux';

const ReorderModal = ({ show, onClose, reorderData }) => {
    const [deliveryDate, setDeliveryDate] = useState(null);
    const dispatch = useDispatch();

    // console.log(reorderData, 'reorderData');


    const allowedDeliveryDayName = reorderData?.OrdersItem?.Menu?.HotMeal ? reorderData?.OrdersItem?.Menu?.HotMeal?.hotMealDay : null; // Or null if not restricted
    const weekDayMap = {
        Sun: 0,
        Mon: 1,
        Tue: 2,
        Wed: 3,
        Thu: 4,
        Fri: 5,
        Sat: 6
    };

    const allowedDeliveryDay = allowedDeliveryDayName ? weekDayMap[allowedDeliveryDayName] : null;

    if (!show || !reorderData) return null;

    const isBefore6AM = () => {
        const now = new Date();
        return now.getHours() < 6;
    };

    const handlePlaceOrder = async () => {
        if (!deliveryDate) {
            alert('Please select a delivery date.');
            return;
        }

        const selectedDate = dayjs(deliveryDate).startOf('day');
        const today = dayjs().startOf('day');

        if (selectedDate.isBefore(today)) {
            alert('Delivery date must be today or a future date.');
            return;
        }

        if (!isBefore6AM() && selectedDate.isSame(today)) {
            alert('You can only place orders for today before 6 AM.');
            return;
        }

        // Proceed with reorder logic
        const obj = {
            childId: reorderData?.Order?.childId,
            deliveryDate: selectedDate.format('DD/MM/YYYY'),
            totalPrice: reorderData?.Order?.totalPrice,
            orderItems: [
                {
                    "menuId": reorderData?.OrdersItem?.Menu?.idMenu,
                    "itemName": reorderData?.OrdersItem?.itemName,
                    "description": reorderData?.OrdersItem?.description,
                    "price": reorderData?.OrdersItem?.price,
                    "quantity": reorderData?.OrdersItem?.quantity
                }
            ]
        };

        console.log('Reordering with:', obj);

        const response = await commonFunction.addOrder(obj);

        if (response.status === 200) {
            toast.success("Bestilling er Gennemført");
            dispatch(getWalletAmount());
        } else {
            toast.error(response?.data?.message || "Failed to place order");
        }
        onClose();

        // Clear input and close modal
        setDeliveryDate(null);

    };

    return (
        <>
            <div className="modal-overlay">
                <div className="modal-container">
                    <div className="modal-header">
                        <h2 dangerouslySetInnerHTML={{
                            __html: `Do you want to Re-order "${reorderData?.OrdersItem?.itemName.replace(/<[^>]+>/g, "")}"`,
                        }}></h2>
                        <button className="modal-close" onClick={onClose}>
                            &times;
                        </button>
                    </div>

                    <div className="modal-body">
                        <div className="menu-details">
                            <h4>Menu Details</h4>
                            <p><strong>Menu Image: </strong>
                                <img
                                    src={
                                        reorderData?.OrdersItem?.image
                                            ? `${image_url}${MENU_IMAGE_PATH}` +
                                            reorderData?.OrdersItem?.image
                                            : ""
                                    }
                                    alt="menu"
                                    style={{
                                        height: '80px',
                                        width: '80px',
                                        borderRadius: '50%',
                                        objectFit: 'cover',
                                        border: '2px solid #ddd'
                                    }}
                                />
                            </p>
                            <div className="row">
                                <div className="col-md-6">
                                    <p><strong>Item:</strong> {reorderData?.OrdersItem?.itemName.replace(/<[^>]+>/g, '')}</p>
                                </div>
                                <div className="col-md-6">
                                    <p><strong>Child Name:</strong> {reorderData?.Order?.Child?.name}</p>
                                </div>
                                <div className="col-md-6">
                                    <p><strong>Price:</strong> {reorderData?.OrdersItem?.price} Kr</p>
                                </div>
                                <div className="col-md-6">
                                    <p><strong>Quantity:</strong> {reorderData?.OrdersItem?.quantity}</p>
                                </div>
                                <div className="col-md-6">
                                    <p><strong>Total:</strong> {reorderData?.Order?.totalPrice} Kr</p>
                                </div>
                                <div className="col-md-6">
                                    {deliveryDate && (
                                        <p>
                                            <strong>Delivery Date:</strong> {dayjs(deliveryDate).format('DD-MM-YYYY')}
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="form-group mt-3">
                            <label><strong>Select Delivery Date:</strong></label><br />
                            <DatePicker
                                style={{ width: '100%' }}
                                value={deliveryDate}
                                showToday={false}
                                onChange={(date) => setDeliveryDate(date)}
                                format={'DD-MM-YYYY'}
                                disabledDate={(current) => {
                                    const today = dayjs().startOf('day');
                                    const isPast = current && current < today;
                                    // If allowedDeliveryDay is null then disable past & weekends only
                                    if (allowedDeliveryDay === null || allowedDeliveryDay === undefined) {
                                        const isWeekend = current && (current.day() === 0 || current.day() === 6);
                                        return isPast || isWeekend;
                                    }
                                    // Otherwise allow only the specific allowed day
                                    const isNotAllowedDay = current && current.day() !== allowedDeliveryDay;
                                    return isPast || isNotAllowedDay;
                                }}
                            />
                        </div>
                    </div>

                    <div className="modal-footer">
                        <Button onClick={onClose}>Close</Button>
                        <Button type="primary" onClick={handlePlaceOrder}>
                            Place Order
                        </Button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ReorderModal